import React from "react";

import "./SmallPrint.css";

type Props = {
    children: JSX.Element | JSX.Element[];
};

export default function SmallPrint(props: Props) {
    return <div className="SmallPrint">{props.children}</div>;
}
